export function isNonBlankString(value: unknown): value is string {
  return typeof value === 'string' && /[^\s]+/.test(value)
}

export function nonBlankString(value: unknown): string | null {
  return isNonBlankString(value) ? value : null
}
